import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NotFoundPage from '@/pages/notFoundPage';
import ImportPage from '@/pages/import';

const Routes = () => (
  <Switch>
    <Route exact path="/import" component={ImportPage} />
    {/* Show Not Found page when url does not match */}
    <Route component={NotFoundPage} />
  </Switch>
);

export default Routes;
